import type React from 'react'

import { clsJoin } from '@/utils'
import { MessageContainer } from '../MessageContainer'
import css from './styles.module.css'
import { useCollapseExpand } from './useCollapseExpand'

interface UserMessageProps {
  children: React.ReactNode
  isDescription?: boolean
}

export const UserMessage: React.FC<UserMessageProps> = ({
  children,
  isDescription = false,
}) => {
  const { contentRef, isExpanded, isCollapsible, setIsExpanded } =
    useCollapseExpand()

  return (
    <MessageContainer>
      {isDescription && (
        <div className={css.message_description}>Project description</div>
      )}

      <div
        ref={contentRef}
        className={clsJoin(css.user_message, isExpanded && css.expanded)}
      >
        {children}

        {isCollapsible && !isExpanded && (
          <button
            type="button"
            className={css.show_more}
            onClick={() => setIsExpanded(true)}
          >
            Show more
          </button>
        )}

        {isCollapsible && isExpanded && (
          <button
            className={css.show_less}
            onClick={() => setIsExpanded(false)}
          >
            Show less
          </button>
        )}
      </div>
    </MessageContainer>
  )
}
